import { httpClient } from "@/app/shared/shared-services/httpClient";
import { environment } from "@/environment";

const URL = environment.loyaltyApiBaseUrl;

export default {
  async fetchApps(query) {
    const url = `${URL}v1/apps${query || ''}`;
    return (await httpClient.get(url)).data;
  },
  async createApp(app) {
    const url = `${URL}v1/apps`;
    return await httpClient.post(url, app);
  },
  async updateApp(app) {
    const url = `${URL}v1/apps/${app.id}`;
    return await httpClient.put(url, app);
  },
  async removeApp(appId) {
    const url = `${URL}v1/apps/${appId}`;
    return await httpClient.delete(url);
  },
};
